module.exports = __webpack_public_path__ + "img/iso1328-2-2020_fig01_tooth-to-tooth-radial-deviation.bb8cc7a8.png";